(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-image-slider"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ── Swiper (carousel) init ── */
  function initSlider(section) {
    var el = section.querySelector('.pis-swiper');
    if (!el || !window.Swiper) return;

    var d = el.dataset;
    var loop = d.loop === 'true';
    var autoplay = d.autoplay === 'true';
    var showNav = d.showNav === 'true';
    var showPagination = d.showPagination === 'true';

    var prevBtn = section.querySelector('.pis-btn--prev');
    var nextBtn = section.querySelector('.pis-btn--next');

    var config = {
      loop: loop,
      grabCursor: true,
      slidesPerView: parseInt(d.slidesMobile) || 1,
      spaceBetween: parseInt(d.spaceBetween) || 16,
      watchOverflow: true,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      },
      breakpoints: {
        600: { slidesPerView: parseInt(d.slidesTablet) || 2 },
        1440: { slidesPerView: parseInt(d.slidesDesktop) || 4 }
      }
    };

    if (autoplay) {
      config.autoplay = {
        delay: parseInt(d.autoplayDelay) || 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }
    if (showNav && prevBtn && nextBtn) {
      config.navigation = { prevEl: prevBtn, nextEl: nextBtn };
    }
    if (showPagination) {
      config.pagination = {
        el: section.querySelector('.pis-pagination'),
        clickable: true
      };
    }

    var swiper = new Swiper(el, config);
    el._swiperInstance = swiper;
  }

  function destroySlider(section) {
    var el = section.querySelector('.pis-swiper');
    if (el && el._swiperInstance) {
      el._swiperInstance.destroy(true, true);
      el._swiperInstance = null;
    }
  }

  /* ── Mobile gallery toggle ── */
  function initMobileGallery(section) {
    var toggle = section.querySelector('.pis-gallery-toggle');
    var gridWrap = section.querySelector('.pis-mobile-grid-wrap');
    var label = section.querySelector('.pis-gallery-toggle__label');
    if (!toggle || !gridWrap) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var opening = !expanded;

      toggle.setAttribute('aria-expanded', String(opening));
      gridWrap.classList.toggle('is-open', opening);
      gridWrap.setAttribute('aria-hidden', String(!opening));

      if (label) {
        label.textContent = opening ? 'Collapse Gallery' : 'View Gallery';
      }
    });
  }

  /* ── Theme editor events ── */
  document.addEventListener('shopify:section:load', function (e) {
    initSlider(e.target);
    initMobileGallery(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    destroySlider(e.target);
  });
  document.addEventListener('shopify:section:reorder', function (e) {
    destroySlider(e.target);
    initSlider(e.target);
  });

  /* ── Init on page load ── */
  document.querySelectorAll('.product-image-slider-section').forEach(function (section) {
    initSlider(section);
    initMobileGallery(section);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-bar"] && !Shopify.designMode) return;
  try {
    
let swiper;

function toggleInfoBarSwiper() {
  const el = document.querySelector('.info-bar.swiper');
  if (!el) return;

  if (window.innerWidth < 991) {
    if (!swiper) {
      swiper = new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
      });
    }
  } else if (swiper) {
    swiper.destroy(true, true);
    swiper = null;
  }
}

toggleInfoBarSwiper();
window.addEventListener('resize', toggleInfoBarSwiper);

  } catch(e) { console.error(e); }
})();
})();
